import Box from "@mui/material/Box";
import StatisticCard from "../../../components/Statistics/StatisticCard";
import {
  buildDefaultLoadingStatisticsCards,
  buildStatisticsCardsFromTotals,
} from "../../../components/Statistics/buildStatisticsCardsFromTotals";
import { useTranslationApp } from "../../../lib/i18next";
import {
  GLOBAL_REPORT_VS_PREVIOUS_WEEK,
  PREVIOUS_PERIOD,
} from "../../../i18n/keysTranslations";

const GlobalReportKpiRow = ({
  totals,
  totalsLastPeriod,
  isLoadingStatistics,
  isLoadingCampaigns,
  isStatisticsSettledForRange = false,
  isPreviousPeriodSettledForRange = false,
}) => {
  const { t } = useTranslationApp();

  const isLoadingCurrent =
    isLoadingCampaigns || isLoadingStatistics || !isStatisticsSettledForRange;

  const showPreviousPeriod =
    !isLoadingCurrent &&
    isPreviousPeriodSettledForRange &&
    totalsLastPeriod != null;

  const previousPeriodLabel = t(
    showPreviousPeriod ? PREVIOUS_PERIOD : GLOBAL_REPORT_VS_PREVIOUS_WEEK
  );

  const statisticsCards = buildStatisticsCardsFromTotals({
    totals: totals || {},
    previousTotals: showPreviousPeriod ? totalsLastPeriod || {} : {},
    showPreviousPeriod,
    t,
  });

  const defaultLoadingCards = buildDefaultLoadingStatisticsCards(t);
  const cardsToRender = isLoadingCurrent
    ? defaultLoadingCards
    : statisticsCards;

  return (
    <Box
      data-pdf-kpi-row
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(auto-fit, minmax(220px, 1fr))",
        },
        gap: 2,
        width: "100%",
      }}
    >
      {cardsToRender.map((stat, index) => (
        <StatisticCard
          key={`${stat.label}-${index}`}
          label={stat.label}
          value={stat.value}
          previousValue={stat.previousValue}
          currency={stat.currency}
          suffix={stat.suffix}
          platformBreakdown={stat.platformBreakdown}
          hideChangeText
          hideIcon
          showPreviousPeriod={showPreviousPeriod}
          previousPeriodLabel={previousPeriodLabel}
          isLoading={isLoadingCurrent}
          growth={stat.growth}
          sparklineValues={stat.sparklineValues}
          sparklineTrend={stat.sparklineTrend}
          sx={{ height: "100%" }}
        />
      ))}
    </Box>
  );
};

export default GlobalReportKpiRow;
